import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UserData } from '../../providers/user-data';
import { MentorApproveSadhanaPage } from '../mentor-approve-sadhana/mentor-approve-sadhana';
import { MenteeApproveSadhanaPage } from '../mentee-approve-sadhana/mentee-approve-sadhana';

/**
 * Generated class for the NotificationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-notification',
  templateUrl: 'notification.html',
})
export class NotificationPage {
  notifications: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, private userData: UserData) {
  }

  ionViewDidLoad() {
    this.getNotification();
  }

  getNotification() {
    this.userData.getNotifications(true).subscribe(
      res => {
        this.notifications = res['data'];
        this.notifications.map(item => {
          if (item.pagename == 'approvesadhana') {
            item.page = MentorApproveSadhanaPage;
          } else if (item.pagename == 'myapprovesadhana') {
            item.page = MenteeApproveSadhanaPage
          }
        })
      }
    )
  }

  goToPage(item) {
    console.log(item);
    this.navCtrl.push(item.page);
  }

}



// WEBPACK FOOTER //
// ./src/pages/notification/notification.ts